module.exports = __webpack_public_path__ + "media/images/athletes/4342-e7339427c77d6e7da35835480f89ea34.png";